module.exports = __webpack_public_path__ + "static/quality-bb0f8d4e2e97b709dd3e0497985159e4.png";